import React from 'react';
import { Link } from 'react-router-dom';
import { FiShield } from 'react-icons/fi'; // Icon for Security Login

const WelcomePage = () => {
  const backgroundImage =
    'https://static.vecteezy.com/system/resources/thumbnails/024/494/104/small_2x/abstract-light-background-blue-background-with-waves-free-photo.jpg';

  const topLeftImage =
    'https://img.freepik.com/premium-vector/cartoon-young-man-returning-lost-wallet-lost-found-service_341509-1088.jpg?w=900';

  return (
    <div
      style={{
        position: 'relative',
        minHeight: '50vh',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '2rem',
        flexWrap: 'wrap',
        flexDirection: 'column',
        fontFamily: 'Poppins, sans-serif',
      }}
    >
      <style>{`
        @media (max-width: 768px) {
          .top-left-img {
            position: static !important;
            margin: 0 auto 1.5rem auto !important;
            width: 160px !important;
            height: 160px !important;
          }

          .welcome-card {
            margin: 0 auto !important;
            padding: 1.5rem 1rem !important;
            width: 100% !important;
          }

          .welcome-card p {
            font-size: 1rem !important;
          }

          .top-right-btn {
            top: 20px !important;
            right: 20px !important;
          }
        }
      `}</style>

      {/* Background overlay */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: '100%',
          backgroundColor: 'rgba(255, 255, 255, 0.6)',
          zIndex: 1,
        }}
      />

      {/* Circular image */}
      <div
        className="top-left-img"
        style={{
          position: 'absolute',
          top: '40px',
          left: '40px',
          width: '250px',
          height: '250px',
          borderRadius: '50%',
          overflow: 'hidden',
          border: '4px solid #fff',
          boxShadow: '0 6px 20px rgba(94, 90, 90, 0.3)',
          zIndex: 2,
        }}
      >
        <img
          src={topLeftImage}
          alt="Lost and Found"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </div>

      {/* Security Login Button */}
      <div
        className="top-right-btn"
        style={{
          position: 'absolute',
          top: '30px',
          right: '30px',
          zIndex: 3,
        }}
      >
        <Link to="/security-login" style={headerButtonStyle('#1B3B6F', 'white')}>
          <FiShield style={{ marginRight: '8px' }} />
          Security
        </Link>
      </div>

      {/* Welcome Card */}
      <div
        className="welcome-card"
        style={{
          zIndex: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderRadius: '16px',
          padding: '2rem 3rem',
          maxWidth: '750px',
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 8px 24px rgba(0,0,0,0.3)',
          marginTop: '100px',
          marginLeft: '300px',
        }}
      >
        <p
          style={{
            color: '#1B3B6F',
            fontSize: '1.2rem',
            maxWidth: '600px',
            margin: '0 auto',
            fontWeight: '500',
            lineHeight: '1.6',
            fontFamily: 'Poppins, sans-serif',
          }}
        >
          Asset Recovery System makes it easy to report lost or found items, 
          match them seamlessly, and get them back to their rightful owners securely and efficiently.
        </p>
      </div>

      {/* 🎯 ROLE DASHBOARDS */}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '2rem',
          justifyContent: 'center',
          marginTop: '3rem',
          zIndex: 2,
        }}
      >
        {/* Admin → shared login */}
        <div style={roleCardStyle('#4c5769ff')}>
          <h3 style={roleCardTitle}>Admin</h3>
          <p style={roleCardDesc}>
            Approve claims, manage security officers, and control the system.
          </p>
          <Link to="/login" style={roleCardButton}>Admin</Link>
        </div>

        {/* Security Officer → separate login */}
        <div style={roleCardStyle('#1976D2')}>
          <h3 style={roleCardTitle}>Security Officer</h3>
          <p style={roleCardDesc}>
            View approved claims and notify users when items are available.
          </p>
          <Link to="/security-login" style={roleCardButton}>Security</Link>
        </div>

        {/* Normal User → shared login */}
        <div style={roleCardStyle('#388E3C')}>
          <h3 style={roleCardTitle}>Normal User</h3>
          <p style={roleCardDesc}>
            Report lost/found items, claim items, and ask questions.
          </p>
          <Link to="/login" style={roleCardButton}>Client</Link>
        </div>
      </div>
    </div>
  );
};

const buttonStyle = (bgColor, textColor) => ({
  backgroundColor: bgColor,
  color: textColor,
  padding: '0.75rem 2rem',
  borderRadius: '8px',
  textDecoration: 'none',
  fontWeight: 'bold',
  fontSize: '1rem',
  transition: 'all 0.3s ease',
  boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  fontFamily: 'Poppins, sans-serif',
});

const headerButtonStyle = (bgColor, textColor) => ({
  ...buttonStyle(bgColor, textColor),
  padding: '0.5rem 1.2rem',
  fontSize: '0.95rem',
});

const roleCardStyle = (color) => ({
  backgroundColor: '#fff',
  border: `3px solid ${color}`,
  borderRadius: '12px',
  padding: '1.5rem',
  width: '280px',
  textAlign: 'center',
  boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  fontFamily: 'Poppins, sans-serif',
});

const roleCardTitle = {
  marginBottom: '0.5rem',
  fontSize: '1.5rem',
  color: '#222', // <-- not blue
  fontWeight: '600',
  fontFamily: 'Poppins, sans-serif',
};

const roleCardDesc = {
  fontSize: '1rem',
  marginBottom: '1rem',
  color: '#555', // <-- not blue
  lineHeight: '1.5',
  fontWeight: '400',
  fontFamily: 'Poppins, sans-serif',
};

const roleCardButton = {
  backgroundColor: '#1B3B6F',
  color: 'white',
  textDecoration: 'none',
  padding: '0.6rem 1.2rem',
  borderRadius: '6px',
  fontWeight: 'bold',
  display: 'inline-block',
  fontFamily: 'Poppins, sans-serif',
};

export default WelcomePage;
